// @flow
import { colors } from 'bench-style-constants';
import React from 'react';
import styled from 'styled-components';

const NoDataMessageLayout = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  min-height: ${({ minHeight }) => minHeight}px;
  text-align: center;
`;

const NoDataMessageHeader = styled.h2`
  color: ${colors.ash};
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 8px;
  padding: 0;
`;

const NoDataMessageText = styled.p`
  color: ${colors.dust};
  font-size: 1rem;
  line-height: 1.5rem;
  margin: 0;
  max-width: 350px;
  padding: 0;
`;

type NoDataMessageProps = {
  minHeight: number,
  message: string,
};

/**
 * The NoDataMessage component represents a formatted message to be shown when there is no data to
 * present. This is used by container components to prevent the need for presentational components
 * to handle zero states.
 */
const NoDataMessage = ({ minHeight, message }: NoDataMessageProps) => (
  <NoDataMessageLayout minHeight={minHeight}>
    <NoDataMessageHeader>Nothing to see here</NoDataMessageHeader>
    <NoDataMessageText>{message}</NoDataMessageText>
  </NoDataMessageLayout>
);

export default NoDataMessage;
